var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{attrs:{"id":"topnav"}},[_c('TopBar')],1),(!_vm.isEducational && !_vm.isOfflineVersion)?_c('div',{attrs:{"id":"cloud-home"}},[_c('cloud-sidebar'),_c('div',{staticClass:"cloud-base-content"},[_vm._t("default")],2)],1):_c('div',{staticClass:"cloud-unavailable-wrap"},[_c('educational-unavailable')],1),_c('OnlineStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }